import { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { categories } from "@/mocks/articles";

export default function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  useEffect(() => {
    setIsMobileMenuOpen(false);
  }, [location.pathname]);

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled
          ? "bg-background-50/95 backdrop-blur-md shadow-sm"
          : "bg-transparent"
      }`}
    >
      <div className="w-full px-6 md:px-10">
        <div className="flex items-center justify-between h-16">
          <Link to="/" className="flex items-center gap-2 whitespace-nowrap cursor-pointer">
            <span className="text-2xl font-heading font-bold text-primary-500">51</span>
            <span className="text-lg font-heading font-semibold text-foreground-900 hidden sm:inline">
              每日大赛
            </span>
          </Link>

          <div className="hidden md:flex items-center gap-1">
            <Link
              to="/"
              className={`px-4 py-2 text-sm font-label rounded-full transition-colors duration-200 whitespace-nowrap cursor-pointer ${
                location.pathname === "/"
                  ? "bg-primary-100 text-primary-700 font-semibold"
                  : "text-foreground-700 hover:text-foreground-900 hover:bg-background-100"
              }`}
            >
              首页
            </Link>
            <div className="relative group">
              <button className="px-4 py-2 text-sm font-label text-foreground-700 hover:text-foreground-900 rounded-full hover:bg-background-100 transition-colors duration-200 whitespace-nowrap cursor-pointer flex items-center gap-1">
                吃瓜分类
                <i className="ri-arrow-down-s-line text-xs"></i>
              </button>
              <div className="absolute top-full left-0 mt-1 w-48 bg-background-50 rounded-lg border border-background-200 shadow-lg opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-all duration-200 py-1">
                {categories.map((cat) => (
                  <Link
                    key={cat.slug}
                    to={`/category/${cat.slug}`}
                    className="block px-4 py-2.5 text-sm text-foreground-700 hover:bg-background-100 hover:text-primary-600 transition-colors duration-150 whitespace-nowrap cursor-pointer"
                  >
                    <i className={`${cat.icon} mr-2 text-primary-500`}></i>
                    {cat.name}
                  </Link>
                ))}
              </div>
            </div>
            <Link
              to="/about"
              className={`px-4 py-2 text-sm font-label rounded-full transition-colors duration-200 whitespace-nowrap cursor-pointer ${
                location.pathname === "/about"
                  ? "bg-primary-100 text-primary-700 font-semibold"
                  : "text-foreground-700 hover:text-foreground-900 hover:bg-background-100"
              }`}
            >
              关于我们
            </Link>
          </div>

          <div className="hidden md:flex items-center gap-3">
            <button className="w-9 h-9 flex items-center justify-center rounded-full bg-background-100 hover:bg-background-200 transition-colors cursor-pointer">
              <i className="ri-search-line text-foreground-600 text-sm"></i>
            </button>
            <Link
              to="/category/wanghong-tafang"
              className="px-5 py-2 bg-primary-500 text-background-50 text-sm font-label rounded-full hover:bg-primary-600 transition-colors duration-200 whitespace-nowrap cursor-pointer flex items-center gap-1"
            >
              <i className="ri-fire-line"></i>
              今日热瓜
            </Link>
          </div>

          <button
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            className="md:hidden w-9 h-9 flex items-center justify-center rounded-full bg-background-100 hover:bg-background-200 transition-colors cursor-pointer"
          >
            <i className={`${isMobileMenuOpen ? "ri-close-line" : "ri-menu-line"} text-foreground-700`}></i>
          </button>
        </div>
      </div>

      {isMobileMenuOpen && (
        <div className="md:hidden bg-background-50 border-t border-background-200">
          <div className="px-6 py-4 flex flex-col gap-1">
            <Link
              to="/"
              className="px-4 py-3 text-sm text-foreground-700 hover:bg-background-100 rounded-lg transition-colors cursor-pointer"
            >
              首页
            </Link>
            <div className="px-4 py-2 text-xs text-foreground-400 font-label">吃瓜分类</div>
            {categories.map((cat) => (
              <Link
                key={cat.slug}
                to={`/category/${cat.slug}`}
                className="px-4 py-3 text-sm text-foreground-700 hover:bg-background-100 rounded-lg transition-colors cursor-pointer flex items-center gap-2"
              >
                <i className={`${cat.icon} text-primary-500`}></i>
                {cat.name}
              </Link>
            ))}
            <Link
              to="/about"
              className="px-4 py-3 text-sm text-foreground-700 hover:bg-background-100 rounded-lg transition-colors cursor-pointer"
            >
              关于我们
            </Link>
            <Link
              to="/category/wanghong-tafang"
              className="mt-2 px-5 py-3 bg-primary-500 text-background-50 text-sm font-label rounded-full text-center hover:bg-primary-600 transition-colors cursor-pointer flex items-center justify-center gap-1"
            >
              <i className="ri-fire-line"></i>
              今日热瓜
            </Link>
          </div>
        </div>
      )}
    </nav>
  );
}